import React, { useEffect, useState } from 'react';
import { withRouter, BrowserRouter, useHistory, useLocation } from 'react-router-dom';
import { isNil, is, path, isEmpty, equals, prop } from 'ramda';
import PropTypes from 'prop-types';
import { CompatRouter } from 'react-router-dom-v5-compat';
import styled from 'styled-components';
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';
import { G as GTMEvents } from './gtmEvents-de8c0069.js';
import { getOS, getBrowser } from '@prima-afp/common-libs/dist/libs/utils';

const ScrollTopRouter = ({
  history
}) => {
  useEffect(() => {
    const routeChanged = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      routeChanged();
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var ScrollTopRouter$1 = withRouter(ScrollTopRouter);

const AppRouter = _ref => {
  let {
    publicRouter,
    privateRouter,
    sessionValidator
  } = _ref;
  if (isNil(sessionValidator)) {
    console.warn('You need to add a session validator');
  }
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompatRouter, null, sessionValidator() ? privateRouter : publicRouter), /*#__PURE__*/React.createElement(ScrollTopRouter$1, null)));
};
AppRouter.propTypes = {
  publicRouter: PropTypes.object,
  privateRouter: PropTypes.object,
  sessionValidator: PropTypes.func
};

const MenuWrapperStyled = styled.div.withConfig({
  displayName: "styles__MenuWrapperStyled",
  componentId: "sc-7qek9u-0"
})(["width:0;height:0;", ""], media.md`
            width: 248px;
            max-height: 100vh;
            padding-top: ${props => props.isTwoLevelMenu ? "40px" : "24px"};
            padding-bottom: 24px;
            padding-right: ${props => props.isTwoLevelMenu ? "16px" : "24px"};
            padding-left: ${props => props.isTwoLevelMenu ? "16px" : "24px"};
            position: relative;
            border-bottom-right-radius: 16px;
            border-top-right-radius:16px;
            background-color: ${props => {
  var _props$theme, _props$theme$colors, _props$theme2;
  return props.isTwoLevelMenu ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : _props$theme$colors.primary : props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.color;
}};
            height: auto;
            ${props => props.isTwoLevelMenu && `box-shadow: 2px 4px 16px #F2F2F2;`}
        `);
const ContendScrollableStyled = styled.div.withConfig({
  displayName: "styles__ContendScrollableStyled",
  componentId: "sc-7qek9u-1"
})(["overflow:auto;width:80%;margin:auto;-webkit-overflow-scrolling:touch;height:", ";", " ", " ", ";"], ({
  marginBottomMobile
}) => marginBottomMobile ? 'calc(100vh - 195px)' : 'calc(100vh - 129px)', media.sm`
    height: calc(100vh - 129px);
  `, media.md`
    height: calc(100vh - 129px);
    width: 100%;
    overflow: unset;
  `, props => props.isTwoLevelMenu && `
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        ::-webkit-scrollbar {
            display: none;
        }
    `);

const PrimaIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "130",
  height: "48",
  viewBox: "0 0 198 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.7492 59.8863H10.6529L9.80746 64.9471C9.46927 67.6462 7.44014 67.8149 4.73463 67.8149C1.18366 67.8149 0 66.4654 0 63.5976C0 62.7541 0.169095 61.742 0.338189 60.8985C1.18366 56.0064 2.53641 53.9821 6.93286 53.9821C8.4547 53.9821 9.80746 54.1508 11.1602 54.4882L10.4838 56.8499C9.30017 56.6812 8.11651 56.6812 6.93286 56.6812C4.22735 56.6812 3.72007 58.3681 3.38188 60.8985C3.21279 61.5733 3.21279 62.248 3.21279 62.9228C3.21279 64.2724 3.72007 65.1158 5.58011 65.1158C6.76376 65.1158 6.93286 64.7784 7.10195 63.935L7.44014 62.248H5.41101L5.7492 59.8863Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3854 67.6458H11.5113L12.6947 60.2233C12.8638 59.5485 12.8638 58.8737 13.0329 58.199C14.3854 57.5242 15.9069 57.1868 17.4285 57.1868C17.7666 57.1868 18.1048 57.1868 18.612 57.1868L17.9357 59.5485H17.2595C16.7523 59.5485 16.2451 59.7172 15.7379 59.8859C15.5688 60.2233 15.5688 60.7294 15.3997 61.2354L14.3854 67.6458Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.6494 57.3557L21.6348 63.5973C21.6348 63.766 21.4657 64.1034 21.6348 64.2721C21.6348 64.9468 21.973 65.2842 22.9876 65.2842C23.4949 65.2842 23.8331 65.2842 24.3403 65.1155C24.5094 64.7781 24.5094 64.2721 24.6785 63.766L25.6931 57.3557H28.5677L27.384 64.7781C27.2149 65.4529 27.2149 66.1277 27.0458 66.8025C25.524 67.4772 24.0021 67.8146 22.4803 67.8146C19.6057 67.8146 18.7602 66.8025 18.7602 65.2842C18.7602 64.7781 18.7602 64.4408 18.9293 63.9347L19.9439 57.3557H22.6494Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.0347 62.4163C36.0347 61.9102 36.2038 61.5728 36.2038 61.0667C36.2038 60.2233 35.8656 59.3798 34.5129 59.3798C34.0056 59.3798 33.6674 59.3798 33.1601 59.5485C32.991 60.0546 32.991 60.392 32.8219 60.898L32.1456 65.1154C32.4838 65.2841 32.8219 65.2841 33.1601 65.2841C35.3584 65.2841 35.6965 64.1032 36.0347 62.4163ZM31.3001 71.357H28.4255L30.1164 60.2233C30.2855 59.5485 30.2855 58.8737 30.4546 58.199C31.8074 57.5242 33.3292 57.1868 34.8511 57.1868C37.7257 57.1868 39.0784 58.0303 39.0784 60.7294C39.0784 61.4041 39.0784 61.9102 38.9093 62.585C38.233 66.6336 36.542 67.8145 33.4983 67.8145C32.991 67.8145 32.3147 67.8145 31.8074 67.6458L31.3001 71.357Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.3217 65.2844C45.6745 65.2844 46.0127 64.6096 46.5199 62.4166C46.5199 61.9105 46.689 61.4044 46.689 60.8984C46.689 59.8862 46.3508 59.5488 45.3363 59.5488C43.9835 59.5488 43.6453 60.0549 43.1381 62.4166C42.969 62.9227 42.969 63.4288 42.969 63.9348C43.1381 64.947 43.4762 65.2844 44.3217 65.2844ZM40.2635 62.4166C40.9398 58.5367 42.2926 57.0184 45.6745 57.0184C48.38 57.0184 49.5636 58.0306 49.5636 60.3923C49.5636 61.0671 49.5636 61.5731 49.3945 62.2479C48.7182 66.1279 47.3654 67.6461 43.9835 67.6461C41.278 67.6461 40.0944 66.6339 40.0944 64.2722C40.0944 63.7661 40.2635 63.0914 40.2635 62.4166Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.6574 67.8149C75.1065 67.8149 73.9228 66.4654 73.9228 63.5976C73.9228 62.7541 74.0919 61.742 74.261 60.8985C75.1065 56.1751 76.4592 53.9821 80.8557 53.9821C82.0393 53.9821 83.223 54.1508 84.4066 54.4882L83.7303 57.0186C82.7157 56.8499 81.8702 56.8499 80.8557 56.6812C78.1502 56.6812 77.6429 58.5368 77.3047 60.8985C77.3047 61.5733 77.1356 62.248 77.1356 62.9228C77.1356 64.2724 77.6429 65.1158 79.5029 65.1158C80.5175 65.1158 81.3629 64.9471 82.3775 64.7784L82.2084 67.3088C81.1939 67.6462 79.8411 67.8149 78.6574 67.8149Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.5822 67.6458H83.7081L84.8916 60.2233C85.0607 59.5485 85.0607 58.8737 85.2297 58.199C86.5822 57.5242 88.1038 57.1868 89.6254 57.1868C89.9635 57.1868 90.3016 57.1868 90.8088 57.1868L90.1326 59.5485H89.4563C88.9491 59.5485 88.4419 59.7172 87.9347 59.8859C87.7657 60.2233 87.7657 60.7294 87.5966 61.2354L86.5822 67.6458Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.2406 56.0063H95.0424L97.2406 52.8011H100.115L97.2406 56.0063ZM94.8733 61.7419C95.3805 61.7419 96.226 61.5732 96.9024 61.5732V61.2358C96.9024 61.0671 96.9024 60.8984 96.9024 60.7297C96.9024 59.8862 96.5642 59.5488 95.5496 59.5488C94.0278 59.5488 93.5205 60.561 93.3514 61.9106L94.8733 61.7419ZM96.0569 57.1872C98.9315 57.1872 99.9461 58.368 99.9461 60.561C99.9461 61.2358 99.9461 61.7419 99.777 62.4166C99.777 62.754 99.6079 62.9227 99.6079 63.2601C98.4242 63.4288 96.226 63.7662 94.8733 63.7662H93.3514C93.3514 63.9349 93.3514 63.9349 93.3514 64.1036C93.3514 65.1157 94.0278 65.2844 95.2115 65.2844C96.3951 65.2844 97.7479 65.1157 98.9315 64.947L98.7624 67.14C97.2406 67.4774 95.7187 67.4774 94.1969 67.4774C91.3223 67.4774 90.4768 65.9592 90.4768 63.9349C90.4768 63.4288 90.4768 62.754 90.6459 62.2479C91.1532 58.7054 92.675 57.1872 96.0569 57.1872Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.839 62.4147C103.839 62.9208 103.67 63.2582 103.67 63.7643C103.67 64.6077 104.008 65.4512 105.36 65.4512C105.868 65.4512 106.206 65.4512 106.713 65.2825C106.882 64.9451 106.882 64.4391 107.051 63.933L107.728 59.8843C107.39 59.7156 107.051 59.7156 106.713 59.7156C104.515 59.547 104.177 60.8965 103.839 62.4147ZM108.742 53.3053H111.617L109.757 64.7764C109.588 65.4512 109.588 66.126 109.419 66.8007C108.066 67.4755 106.544 67.8129 105.022 67.8129C102.148 67.8129 100.795 66.9694 100.795 64.2704C100.795 63.5956 100.795 63.0895 100.964 62.4147C101.64 58.3661 103.162 57.1853 106.375 57.1853C106.882 57.1853 107.39 57.1853 107.897 57.3539L108.742 53.3053Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.692 54.6571C116.523 55.8379 116.015 56.1753 114.832 56.1753C113.649 56.1753 113.31 55.8379 113.31 55.1631C113.31 54.9944 113.31 54.8257 113.31 54.6571C113.48 53.4762 113.987 53.1388 115.17 53.1388C116.354 53.1388 116.692 53.4762 116.692 54.151C116.692 54.3197 116.692 54.4884 116.692 54.6571ZM113.141 57.3561H116.015L114.325 67.6464H111.451L113.141 57.3561Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.282 54.3207L121.775 57.1885H123.804L123.466 59.3815H121.437L120.761 64.2736C120.761 64.4423 120.761 64.4423 120.761 64.611C120.761 65.1171 121.099 65.4544 121.606 65.4544H122.62L122.451 67.6474C121.775 67.8161 121.099 67.8161 120.423 67.8161C118.563 67.8161 117.718 67.1414 117.718 65.6231C117.718 65.2858 117.718 65.1171 117.718 64.7797L118.563 59.5502H117.041L117.379 57.3572H119.07L119.408 54.8268L122.282 54.3207Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.202 65.2844C129.555 65.2844 130.062 64.6096 130.401 62.4166C130.57 61.9105 130.57 61.4044 130.57 60.8984C130.57 59.8862 130.232 59.5488 129.217 59.5488C127.864 59.5488 127.526 60.0549 127.019 62.4166C126.85 62.9227 126.85 63.4288 126.85 63.9348C126.85 64.947 127.188 65.2844 128.202 65.2844ZM124.144 62.4166C124.821 58.5367 126.173 57.0184 129.555 57.0184C132.261 57.0184 133.444 58.0306 133.444 60.3923C133.444 61.0671 133.444 61.5731 133.275 62.2479C132.599 66.1279 131.246 67.4774 127.864 67.4774C125.159 67.4774 123.975 66.4652 123.975 64.1035C123.975 63.5975 123.975 63.0914 124.144 62.4166Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.9043 60.394C63.4262 56.8514 63.2571 52.6341 61.228 51.2846C61.0589 51.1159 60.8898 51.1159 60.8898 51.1159C58.6915 50.1037 56.8315 52.2967 56.1551 53.1402C55.6478 53.815 55.1406 54.6584 54.8024 55.5019C57.3388 56.5141 59.8752 58.201 61.9043 60.394Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.8379 57.692C70.36 59.5477 70.5292 62.078 69.1761 64.1024C66.47 67.6449 62.9183 70.5127 58.8592 72.537C55.6457 74.0552 52.9396 71.5249 51.7557 69.5005C55.3075 67.9823 58.3518 65.6206 60.7196 62.5841C63.2566 58.7042 63.4257 53.1373 61.0579 51.4504C62.5801 52.2939 63.9331 53.306 65.117 54.3182C66.6392 55.1616 67.654 56.3425 68.8379 57.692Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.79477 15.5213H10.3169C13.5304 15.5213 16.5748 15.5213 16.5748 11.4727C16.5748 7.42404 13.6995 7.25535 10.3169 7.25535H8.79477V15.5213ZM0 0.17025H13.5304C20.803 0.17025 25.8769 3.54411 25.8769 11.304C25.8769 19.0639 21.6487 22.7751 13.8687 22.7751H8.79477V33.9088H0V0.17025Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0567 15.3568H38.9023C41.7776 15.3568 44.991 14.8508 44.991 11.1395C44.991 7.42826 41.7776 6.92218 38.9023 6.92218H38.0567V15.3568ZM57.5067 33.913H46.5132L38.2258 20.9237V33.913H29.431V0.174469H42.6232C49.3884 0.174469 54.4623 3.37964 54.4623 10.4647C54.4623 15.1881 51.9254 19.2368 47.0206 20.0802L57.5067 33.913Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.6736 0.172596H60.8807V33.9112H69.6736V0.172596Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.1554 0.172596H87.9502L94.7154 18.2227L101.988 0.172596H110.783L115.857 33.9112H107.062L104.525 14.5115L96.4067 33.9112H92.855L85.075 14.5115L82.1998 33.9112H73.405L79.1554 0.172596Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.468 10.6316L131.747 21.4279H139.02L135.468 10.6316ZM129.379 28.0069L127.011 33.9112H117.709L130.732 0.172596H140.373L153.057 33.9112H143.755L141.557 28.0069H129.379Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.025 5.39817L160.164 10.7963H163.885L162.025 5.39817ZM158.981 14.0015L157.797 16.8693H153.061L159.488 0H164.224L170.65 16.8693H165.915L164.731 14.0015H158.981Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.9 3.88477V6.58386H181.635V10.4638H176.9V17.0428H172.504V0.173531H182.142V3.88477H176.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.411 7.93106H190.087C191.609 7.93106 193.301 7.93106 193.301 5.90675C193.301 3.88243 191.779 3.71374 190.087 3.71374H189.411V7.93106ZM185.013 0.171188H191.779C195.499 0.171188 197.867 1.85812 197.867 5.73805C197.867 9.61799 195.669 11.4736 191.948 11.4736H189.411V17.0405H185.013V0.171188Z",
  fill: "white"
}));
const PrimaColorIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "98",
  height: "19",
  viewBox: "0 0 98 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.0427 5.26402L86.7016 4.17394H85.012L84.6868 5.26402H83.1343L84.8995 0H86.83L88.5952 5.26402H87.0427ZM85.3461 3.04519H86.3465L85.8313 1.39424L85.3461 3.04519ZM89.0682 5.26578V0.00175991H92.8852V1.37315H90.5521V2.1239H92.4527V3.49528H90.5521V5.26754H89.0682V5.26578ZM93.5252 5.26578V0H95.9269C96.5071 0 96.9888 0.165271 97.3703 0.495811C97.7519 0.826351 97.9418 1.27293 97.9418 1.83379C97.9418 2.39465 97.7519 2.83948 97.3703 3.17002C96.9888 3.50056 96.5071 3.66583 95.9269 3.66583H95.0109V5.26402H93.5252V5.26578ZM95.0109 2.39465H95.7071C96.1625 2.39465 96.3893 2.20829 96.3893 1.83379C96.3893 1.4593 96.1537 1.27293 95.6842 1.27293H95.0109V2.39465ZM64.5326 18.4276H59.2985V6.98177L56.0669 18.4276H52.0249L48.5366 7.00815V18.4276H43.3025V0.00175991H50.1612L54.0186 11.866L57.848 0.00175991H64.5309V18.4276H64.5326ZM33.2298 13.7578V18.3327C32.7709 18.4733 32.3068 18.526 31.7424 18.526C29.942 18.526 28.5284 18.141 27.3188 17.4008C26.1109 16.6606 25.172 15.3209 24.3474 13.2655L24.0169 12.4199H22.2534V18.4258H17.2936V0.00175991H26.0529C28.0994 0.00175991 29.789 0.571412 31.1217 1.70896C32.4544 2.84651 33.119 4.39548 33.119 6.3541C33.119 7.6956 32.7832 8.8015 32.1133 9.67532C31.4435 10.5491 30.2936 11.0977 29.0752 11.4687C29.506 12.2458 30.1705 12.9051 30.6998 13.306C31.5507 13.9495 32.9045 13.7965 33.2298 13.7578ZM22.2534 4.24427V8.18262H25.2845C26.9847 8.18262 27.8357 7.52154 27.8357 6.19938C27.8357 4.89656 26.9566 4.24427 25.2001 4.24427H22.2534ZM0 18.4276V0.00175991H8.38833C10.4173 0.00175991 12.0964 0.580202 13.4291 1.73533C14.76 2.89046 15.4264 4.44822 15.4264 6.40509C15.4264 8.36371 14.76 9.91971 13.4291 11.0748C12.0964 12.23 10.4173 12.8084 8.38833 12.8084H5.01436V18.4276H0ZM4.98975 8.5114H7.61648C9.32896 8.5114 10.187 7.80813 10.187 6.39806C10.187 4.98975 9.30258 4.28471 7.53209 4.28471H4.99151V8.5114H4.98975ZM35.6456 18.4276V0.00175991H40.6283V18.4293H35.6456V18.4276ZM84.9206 18.4276L78.737 0H72.0999L65.9216 18.4276H71.1118L72.0419 15.2804C73.0669 15.6233 74.1851 15.7956 75.3947 15.7956C76.6026 15.7956 77.719 15.6233 78.7423 15.2822L79.7234 18.4276H84.9206ZM75.3947 11.0502C74.6545 11.0502 73.997 10.9008 73.4238 10.6019L75.2998 4.24603L77.2936 10.637C76.738 10.9113 76.105 11.0502 75.3947 11.0502Z",
  fill: "#FF4F00"
}));
const BaseMenuButton = styled.button.withConfig({
  displayName: "styles__BaseMenuButton",
  componentId: "sc-cup5id-0"
})(["width:88px;height:40px;border-radius:8px;display:flex;padding-top:9.5px;padding-bottom:9.5px;padding-left:8px;padding-right:18px;align-items:center;justify-content:space-between;background:", ";"], props => props.color);
const BarsIcon = ({
  color = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  width: "18",
  height: "2.66551",
  rx: "1.33275",
  transform: "matrix(-1 0 0 1 18 0)",
  fill: color
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 7.97197C18 7.17143 17.351 6.52246 16.5505 6.52246H1.44951C0.648966 6.52246 0 7.17143 0 7.97197C0 8.77251 0.648968 9.42148 1.44951 9.42148H16.5505C17.351 9.42148 18 8.77251 18 7.97197Z",
  fill: color
}), /*#__PURE__*/React.createElement("rect", {
  width: "18",
  height: "2.66551",
  rx: "1.33276",
  transform: "matrix(-1 0 0 1 18 13.335)",
  fill: color
}));
const CloseIcon = ({
  color = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 2.00021L2 21.0002",
  stroke: color,
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 2L21 21",
  stroke: color,
  strokeWidth: "4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const LogoWrapperStyled = styled.div.withConfig({
  displayName: "styles__LogoWrapperStyled",
  componentId: "sc-cup5id-1"
})(["svg{width:88px;}", ""], media.md`
        width: ${props => props.isTwoLevelMenu ? "114px" : "130px"};
        svg {
            width: 100%;
        }
        margin-bottom: ${props => props.isTwoLevelMenu ? "42px" : "32px"};
    `);
const HeaderWrapperStyled = styled.div.withConfig({
  displayName: "styles__HeaderWrapperStyled",
  componentId: "sc-cup5id-2"
})(["position:fixed;top:0;left:0;z-index:4;height:63px;right:0;background-color:", ";padding:14px 36px;display:flex;justify-content:space-between;align-items:center;", ""], props => {
  var _props$theme, _props$theme$colors, _props$theme2;
  return props.isTwoLevelMenu ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : _props$theme$colors.primary : props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.color;
}, media.md`
            position: relative;
            padding: 0;
            height: auto;
        `);
const ToggleMenuIconStyled = styled.div.withConfig({
  displayName: "styles__ToggleMenuIconStyled",
  componentId: "sc-cup5id-3"
})(["cursor:pointer;", ""], media.md`
        display: none;
    `);
const MenuTitleStyled = styled.p.withConfig({
  displayName: "styles__MenuTitleStyled",
  componentId: "sc-cup5id-4"
})(["font-style:normal;font-weight:700;font-size:14px;line-height:21px;color:", ";"], props => (props === null || props === void 0 ? void 0 : props.color) || "white");

const Logo = ({
  theme,
  isTwoLevelMenu
}) => {
  return /*#__PURE__*/React.createElement(LogoWrapperStyled, {
    isTwoLevelMenu: isTwoLevelMenu
  }, theme === "white" ? /*#__PURE__*/React.createElement(PrimaColorIcon, null) : /*#__PURE__*/React.createElement(PrimaIcon, null));
};

const UserIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9.9997 3C11.6597 3 12.9997 4.34 12.9997 6C12.9997 7.66 11.6597 9 9.9997 9C8.3397 9 6.9997 7.66 6.9997 6C6.9997 4.34 8.3397 3 9.9997 3ZM4.00033 13.9801C5.29033 15.9201 7.50033 17.2001 10.0003 17.2001C12.5003 17.2001 14.7103 15.9201 16.0003 13.9801C15.9703 11.9901 11.9903 10.9001 10.0003 10.9001C8.00033 10.9001 4.03033 11.9901 4.00033 13.9801Z",
  fill: "white"
}));
const StyledCircle = styled.div.withConfig({
  displayName: "styles__StyledCircle",
  componentId: "sc-ccs8tu-0"
})(["height:32px;width:32px;background-color:", ";border-radius:50%;display:flex;align-items:center;justify-content:center;"], props => props === null || props === void 0 ? void 0 : props.color);
const StyledCircleInitials = styled.h1.withConfig({
  displayName: "styles__StyledCircleInitials",
  componentId: "sc-ccs8tu-1"
})(["font-weight:700;font-size:12px;line-height:14px;color:", ";"], props => props === null || props === void 0 ? void 0 : props.color);
const UserCircle = ({
  color,
  secondaryColor,
  nameInitials
}) => {
  return /*#__PURE__*/React.createElement(StyledCircle, {
    color: secondaryColor
  }, /*#__PURE__*/React.createElement(StyledCircleInitials, {
    color: color
  }, nameInitials));
};
const UserCardSeparator = styled.hr.withConfig({
  displayName: "styles__UserCardSeparator",
  componentId: "sc-ccs8tu-2"
})(["margin-top:24px;border:1px solid #ececec;display:none;", ""], media.md`
    display: flex;
    `);
const UserIconWrapperStyled = styled.div.withConfig({
  displayName: "styles__UserIconWrapperStyled",
  componentId: "sc-ccs8tu-3"
})(["margin-right:10px;display:flex;align-items:center;"]);
const TitleStyled = styled.p.withConfig({
  displayName: "styles__TitleStyled",
  componentId: "sc-ccs8tu-4"
})(["font-weight:600;font-size:16px;line-height:20px;display:block;color:", ";"], props => {
  var _props$theme, _props$theme$colors, _props$theme$colors$t;
  return (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : (_props$theme$colors$t = _props$theme$colors.text) === null || _props$theme$colors$t === void 0 ? void 0 : _props$theme$colors$t.dark) || "white";
});
const SubTitleStyled = styled.p.withConfig({
  displayName: "styles__SubTitleStyled",
  componentId: "sc-ccs8tu-5"
})(["font-size:12px;line-height:14px;margin-top:2px;text-transform:uppercase;color:", ";"], props => {
  var _props$theme2, _props$theme2$colors, _props$theme2$colors$;
  return (props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$colors = _props$theme2.colors) === null || _props$theme2$colors === void 0 ? void 0 : (_props$theme2$colors$ = _props$theme2$colors.text) === null || _props$theme2$colors$ === void 0 ? void 0 : _props$theme2$colors$.dark) || "white";
});

const CustomLinkStyled = styled.a.withConfig({
  displayName: "styles__CustomLinkStyled",
  componentId: "sc-1ywob5m-0"
})(["display:flex;align-items:center;font-size:16px;line-height:18px;cursor:pointer;height:", ";"], props => props.isTwoLevelMenu ? "36px" : "50px");
const NavigationListStyled = styled.ul.withConfig({
  displayName: "styles__NavigationListStyled",
  componentId: "sc-1ywob5m-1"
})(["margin-top:16px;", ""], media.md`
    margin-top: 32px;
    ${props => props.isTwoLevelMenu && `
        height: calc(100vh - 280px);
        overflow-y: scroll;
        overflow-x: hidden;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        ::-webkit-scrollbar {
            display: none;
        }
    `};
    `);
const NavigationIconWrapperStyled = styled.div.withConfig({
  displayName: "styles__NavigationIconWrapperStyled",
  componentId: "sc-1ywob5m-2"
})(["margin-right:8px;width:", ";height:", ";img,svg{width:100%;}svg{path{", ";}.svg_fill_eq_stroke{", ";}}}"], props => props.isTwoLevelMenu ? "24px" : "16px", props => props.isTwoLevelMenu ? "24px" : "16px", props => {
  var _props$theme, _props$theme$colors, _props$theme$colors$t, _props$theme2, _props$theme2$colors, _props$theme2$colors$, _props$theme3, _props$theme3$colors, _props$theme3$colors$;
  return props.isTwoLevelMenu && `stroke:${props.hoverColor ? (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : (_props$theme$colors$t = _props$theme$colors.text) === null || _props$theme$colors$t === void 0 ? void 0 : _props$theme$colors$t.hover : props.isCurrentLocation ? (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$colors = _props$theme2.colors) === null || _props$theme2$colors === void 0 ? void 0 : (_props$theme2$colors$ = _props$theme2$colors.text) === null || _props$theme2$colors$ === void 0 ? void 0 : _props$theme2$colors$.active : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$colors = _props$theme3.colors) === null || _props$theme3$colors === void 0 ? void 0 : (_props$theme3$colors$ = _props$theme3$colors.text) === null || _props$theme3$colors$ === void 0 ? void 0 : _props$theme3$colors$.color}`;
}, props => {
  var _props$theme4, _props$theme4$colors, _props$theme4$colors$, _props$theme5, _props$theme5$colors, _props$theme5$colors$, _props$theme6, _props$theme6$colors, _props$theme6$colors$;
  return props.isTwoLevelMenu && `fill:${props.hoverColor ? (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : (_props$theme4$colors = _props$theme4.colors) === null || _props$theme4$colors === void 0 ? void 0 : (_props$theme4$colors$ = _props$theme4$colors.text) === null || _props$theme4$colors$ === void 0 ? void 0 : _props$theme4$colors$.hover : props.isCurrentLocation ? (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : (_props$theme5$colors = _props$theme5.colors) === null || _props$theme5$colors === void 0 ? void 0 : (_props$theme5$colors$ = _props$theme5$colors.text) === null || _props$theme5$colors$ === void 0 ? void 0 : _props$theme5$colors$.active : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : (_props$theme6$colors = _props$theme6.colors) === null || _props$theme6$colors === void 0 ? void 0 : (_props$theme6$colors$ = _props$theme6$colors.text) === null || _props$theme6$colors$ === void 0 ? void 0 : _props$theme6$colors$.color}`;
});
const commonCircle = () => props => {
  var _props$theme7, _props$theme8;
  return `
    width: 16px;
    height: 16px;
    position: absolute;
    background: var(--grayColorCard);
    right: 0px;
    &:before {
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        border: 6px solid ${props === null || props === void 0 ? void 0 : (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.color};
        background: ${props === null || props === void 0 ? void 0 : (_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.color};
    }
`;
};
const QuaterCircleTop = styled.div.withConfig({
  displayName: "styles__QuaterCircleTop",
  componentId: "sc-1ywob5m-3"
})(["", " top:-16px;&:before{border-radius:0 0 100px 0;}"], commonCircle());
const QuaterCircleBottom = styled.div.withConfig({
  displayName: "styles__QuaterCircleBottom",
  componentId: "sc-1ywob5m-4"
})(["", " bottom:-16px;&:before{border-radius:0 100px 0 0;}"], commonCircle());
const NavigationItemStyled = styled.li.withConfig({
  displayName: "styles__NavigationItemStyled",
  componentId: "sc-1ywob5m-5"
})(["height:70px;padding:10px auto;justify-content:space-between;align-items:center;list-style:none;border-radius:8px;background:", ";", " ", " ", ""], props => props.subMenuActive && (props === null || props === void 0 ? void 0 : props.isCurrent) && "#FFF6F2", props => props.isTwoLevelMenu && `display:flex;
    `, media.md`
            height: auto;
            padding: 0;
            padding-left: 8px;
            justify-content: space-between;
            ${props => props.isTwoLevelMenu && `
                height: 56px;
                display:flex;
                align-items:center;
                `}
        `, props => props.isCurrent & !props.isTwoLevelMenu ? `
            color: #ffffff;
            background-color: rgba(0, 0, 0, 0.1);
            svg, path {
                fill: #ffffff;
            }
            ${media.md`
                    background: #ffffff;
                    color: var(--orangeColorMain);
                    border-top-left-radius: 24px;
                    border-bottom-left-radius: 24px;
                    font-weight: bold;
                    padding-left: 24px;
                    margin-right: -24px;
                    background-color: var(--grayColorCard);
                    position: relative;
                    svg, path {
                        fill: var(--orangeColorMain);
                    }
                `}
        ` : `
            color: #ffffff;
        `);
const StyledItemText = styled.p.withConfig({
  displayName: "styles__StyledItemText",
  componentId: "sc-1ywob5m-6"
})(["font-style:normal;font-weight:700;font-size:14px;line-height:16px;display:flex;padding:5px 10px;justify-content:center;align-items:center;", ";color:", ";height:", ";border-radius:8px;background:", ";&:hover{color:", ";}", " ", ""], props => !(props !== null && props !== void 0 && props.showIcon) && `margin-left:12px`, props => (props === null || props === void 0 ? void 0 : props.color) || "white", props => props.subMenuActive && (props === null || props === void 0 ? void 0 : props.isCurrentLocation) && "40px", props => props.subMenuActive && (props === null || props === void 0 ? void 0 : props.isCurrentLocation) && "#FFF6F2", props => (props === null || props === void 0 ? void 0 : props.onHoverColor) || (props === null || props === void 0 ? void 0 : props.color) || "white", props => (props === null || props === void 0 ? void 0 : props.isCurrentLocation) && `
    color: ${(props === null || props === void 0 ? void 0 : props.activeColor) || "white"};
    &:hover {
        color: ${(props === null || props === void 0 ? void 0 : props.activeColor) || "white"};
    }
    `, media.md`
    ${props => props !== null && props !== void 0 && props.showIcon ? `max-width: 122px;` : `max-width: 142px;`};
    `);
const Notification = styled.div.withConfig({
  displayName: "styles__Notification",
  componentId: "sc-1ywob5m-7"
})(["font-family:'Calibri';font-style:normal;font-weight:700;margin-right:1em;font-size:13px;border-radius:8px;display:flex;align-items:center;justify-content:center;width:26px;height:26px;background:", ";"], props => {
  var _props$theme9;
  return props === null || props === void 0 ? void 0 : (_props$theme9 = props.theme) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.color;
});

const NavigationItemContainer = ({
  isCurrentLocation,
  children,
  theme,
  isTwoLevelMenu,
  subMenuActive
}) => {
  return /*#__PURE__*/React.createElement(NavigationItemStyled, {
    isCurrent: isCurrentLocation,
    isTwoLevelMenu: isTwoLevelMenu,
    subMenuActive: subMenuActive
  }, children, isCurrentLocation && !isTwoLevelMenu && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuaterCircleTop, {
    theme: theme
  }), /*#__PURE__*/React.createElement(QuaterCircleBottom, {
    theme: theme
  })));
};

const CustomLink$1 = ({
  children,
  to,
  onNavigate,
  isTwoLevelMenu,
  onLinkClick = () => {}
}) => {
  const history = useHistory();
  const continueNavigation = () => history.push(to);
  const handleNavigationClick = () => {
    onLinkClick();
    if (!isNil(onNavigate) && is(Function, onNavigate)) onNavigate({
      continueNavigation
    });else continueNavigation();
  };
  return /*#__PURE__*/React.createElement(CustomLinkStyled, {
    onClick: handleNavigationClick,
    isTwoLevelMenu: isTwoLevelMenu
  }, children);
};

const UserInformation = ({
  title,
  subTitle,
  onNavigate,
  userModule,
  theme,
  isTwoLevelMenu,
  nameInitials
}) => {
  var _theme$colors, _theme$colors2;
  const {
    pathname
  } = useLocation();
  const userModulePath = path(['config', 'informationPage'], userModule);
  const isCurrentLocation = pathname.includes(userModulePath);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationItemContainer, {
    isCurrentLocation: isCurrentLocation,
    theme: theme
  }, /*#__PURE__*/React.createElement(CustomLink$1, {
    to: userModulePath,
    onNavigate: onNavigate,
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement(UserIconWrapperStyled, null, isTwoLevelMenu ? /*#__PURE__*/React.createElement(UserCircle, {
    color: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.primary,
    secondaryColor: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.secondary,
    nameInitials: nameInitials
  }) : /*#__PURE__*/React.createElement(UserIcon, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TitleStyled, {
    theme: theme
  }, title), subTitle && /*#__PURE__*/React.createElement(SubTitleStyled, {
    theme: theme
  }, subTitle)))), isTwoLevelMenu && /*#__PURE__*/React.createElement(UserCardSeparator, null));
};

const LogoutIcon = ({
  color = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83333 0.708333C2.83333 1.09792 2.51458 1.41667 2.125 1.41667H1.41667V9.91667H2.125C2.51458 9.91667 2.83333 10.2354 2.83333 10.625C2.83333 11.0146 2.51458 11.3333 2.125 11.3333H0.708333C0.31875 11.3333 0 11.0146 0 10.625V0.708333C0 0.31875 0.31875 0 0.708333 0H2.125C2.51458 0 2.83333 0.31875 2.83333 0.708333ZM9.91934 2.42606L11.9126 5.2594C12.0897 5.51015 12.084 5.84661 11.8998 6.09169L9.77484 8.92502C9.636 9.11061 9.4228 9.20835 9.20746 9.20835C9.06013 9.20835 8.91067 9.16231 8.78317 9.06669C8.47009 8.83223 8.40705 8.38811 8.6415 8.07573L9.91721 6.37502H9.9165H4.24984C3.85884 6.37502 3.5415 6.0584 3.5415 5.66669C3.5415 5.27498 3.85884 4.95836 4.24984 4.95836H9.9165C9.92822 4.95836 9.93906 4.96158 9.95 4.96483C9.95891 4.96748 9.96788 4.97015 9.97742 4.97111L8.7605 3.24065C8.53525 2.92119 8.61246 2.47919 8.93263 2.25394C9.25209 2.02798 9.69409 2.1059 9.91934 2.42606Z",
  fill: color
}));
const ReverseLogoutIcon = ({
  color = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.1667 13.2917C11.1667 12.9021 11.4854 12.5833 11.875 12.5833L12.5833 12.5833L12.5833 4.08333L11.875 4.08333C11.4854 4.08333 11.1667 3.76458 11.1667 3.375C11.1667 2.98542 11.4854 2.66667 11.875 2.66667L13.2917 2.66667C13.6813 2.66667 14 2.98542 14 3.375L14 13.2917C14 13.6813 13.6813 14 13.2917 14L11.875 14C11.4854 14 11.1667 13.6812 11.1667 13.2917ZM4.08066 11.5739L2.08741 8.7406C1.91033 8.48985 1.916 8.15339 2.10016 7.90831L4.22516 5.07498C4.364 4.88939 4.5772 4.79164 4.79254 4.79164C4.93987 4.79164 5.08933 4.83769 5.21683 4.93331C5.52991 5.16777 5.59296 5.61189 5.3585 5.92427L4.08279 7.62498L4.0835 7.62498L9.75016 7.62498C10.1412 7.62498 10.4585 7.9416 10.4585 8.33331C10.4585 8.72502 10.1412 9.04164 9.75016 9.04164L4.0835 9.04164C4.07179 9.04164 4.06094 9.03842 4.05 9.03516C4.04109 9.03251 4.03212 9.02985 4.02258 9.02889L5.2395 10.7594C5.46475 11.0788 5.38754 11.5208 5.06737 11.7461C4.74791 11.972 4.30591 11.8941 4.08066 11.5739Z",
  fill: color
}));
const CloseSessionTextStyled = styled.p.withConfig({
  displayName: "styles__CloseSessionTextStyled",
  componentId: "sc-aetbc8-0"
})(["font-size:16px;line-height:18px;margin-left:10px;"]);
const CloseSessionWrapperStyled = styled.div.withConfig({
  displayName: "styles__CloseSessionWrapperStyled",
  componentId: "sc-aetbc8-1"
})(["padding:24px 12%;background-color:", ";", ""], props => {
  var _props$theme;
  return props.isTwoLevelMenu ? '#F6F6F7' : props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.color;
}, media.md`
        position: absolute;
        bottom: 32px;
        padding: 24px;
        left: -20px;
        min-width: 260px;
        max-width: 260px;
        height: 64px;
    `);
const CustomLink = styled.a.withConfig({
  displayName: "styles__CustomLink",
  componentId: "sc-aetbc8-2"
})(["display:flex;align-items:center;color:", ";", " ", ""], props => {
  var _props$theme2, _props$theme2$colors, _props$theme2$colors$;
  return (props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$colors = _props$theme2.colors) === null || _props$theme2$colors === void 0 ? void 0 : (_props$theme2$colors$ = _props$theme2$colors.text) === null || _props$theme2$colors$ === void 0 ? void 0 : _props$theme2$colors$.dark) || "white";
}, props => {
  var _props$theme3;
  return (props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name) === "white" && `font-weight: 700;
    font-size: 14px;
    line-height: 16px;`;
}, props => (props === null || props === void 0 ? void 0 : props.isTwoLevelMenu) && `padding-left:8px`);

const CloseSession = ({
  onClick,
  theme,
  isTwoLevelMenu
}) => {
  var _theme$colors, _theme$colors$text;
  return /*#__PURE__*/React.createElement(CloseSessionWrapperStyled, {
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement(CustomLink, {
    onClick: onClick,
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu
  }, isTwoLevelMenu ? /*#__PURE__*/React.createElement(ReverseLogoutIcon, {
    color: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$text = _theme$colors.text) === null || _theme$colors$text === void 0 ? void 0 : _theme$colors$text.dark
  }) : /*#__PURE__*/React.createElement(LogoutIcon, {
    color: 'theme?.colors?.text?.dark'
  }), /*#__PURE__*/React.createElement(CloseSessionTextStyled, null, "Cerrar Sesi\xF3n")));
};

const DeployArrow = ({
  theme,
  isCurrentLocation
}) => {
  var _theme$colors, _theme$colors$text, _theme$colors2, _theme$colors2$text, _theme$colors3, _theme$colors3$text, _theme$colors4, _theme$colors4$text;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99997 11C8.1954 11 8.38997 10.934 8.54855 10.8011L13.6915 6.51522C14.0549 6.21263 14.1047 5.67175 13.8012 5.3083C13.4986 4.94486 12.9586 4.896 12.5943 5.19773L7.99054 9.03534L3.39445 5.33659C3.02587 5.04001 2.48586 5.09829 2.18929 5.46688C1.89271 5.83547 1.951 6.37464 2.31957 6.67208L7.46253 10.8106C7.61939 10.9366 7.80968 11 7.99997 11Z",
    fill: isCurrentLocation ? theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$text = _theme$colors.text) === null || _theme$colors$text === void 0 ? void 0 : _theme$colors$text.active : theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : (_theme$colors2$text = _theme$colors2.text) === null || _theme$colors2$text === void 0 ? void 0 : _theme$colors2$text.color
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.01",
    width: "16",
    height: "16",
    transform: "matrix(1 1.19249e-08 1.19249e-08 -1 0 16)",
    fill: isCurrentLocation ? theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : (_theme$colors3$text = _theme$colors3.text) === null || _theme$colors3$text === void 0 ? void 0 : _theme$colors3$text.active : theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : (_theme$colors4$text = _theme$colors4.text) === null || _theme$colors4$text === void 0 ? void 0 : _theme$colors4$text.color
  }));
};
const ContractedArrow = ({
  theme,
  isCurrentLocation
}) => {
  var _theme$colors5, _theme$colors5$text, _theme$colors6, _theme$colors6$text, _theme$colors7, _theme$colors7$text, _theme$colors8, _theme$colors8$text;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99997 5C8.1954 5 8.38997 5.066 8.54855 5.19887L13.6915 9.48478C14.0549 9.78737 14.1047 10.3283 13.8012 10.6917C13.4986 11.0551 12.9586 11.104 12.5943 10.8023L7.99054 6.96466L3.39445 10.6634C3.02587 10.96 2.48586 10.9017 2.18929 10.5331C1.89271 10.1645 1.951 9.62536 2.31957 9.32792L7.46253 5.18944C7.61939 5.06343 7.80968 5 7.99997 5Z",
    fill: isCurrentLocation ? theme === null || theme === void 0 ? void 0 : (_theme$colors5 = theme.colors) === null || _theme$colors5 === void 0 ? void 0 : (_theme$colors5$text = _theme$colors5.text) === null || _theme$colors5$text === void 0 ? void 0 : _theme$colors5$text.active : theme === null || theme === void 0 ? void 0 : (_theme$colors6 = theme.colors) === null || _theme$colors6 === void 0 ? void 0 : (_theme$colors6$text = _theme$colors6.text) === null || _theme$colors6$text === void 0 ? void 0 : _theme$colors6$text.color
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.01",
    width: "16",
    height: "16",
    transform: "matrix(1 1.19249e-08 1.19249e-08 -1 0 16)",
    fill: isCurrentLocation ? theme === null || theme === void 0 ? void 0 : (_theme$colors7 = theme.colors) === null || _theme$colors7 === void 0 ? void 0 : (_theme$colors7$text = _theme$colors7.text) === null || _theme$colors7$text === void 0 ? void 0 : _theme$colors7$text.active : theme === null || theme === void 0 ? void 0 : (_theme$colors8 = theme.colors) === null || _theme$colors8 === void 0 ? void 0 : (_theme$colors8$text = _theme$colors8.text) === null || _theme$colors8$text === void 0 ? void 0 : _theme$colors8$text.color
  }));
};

const getPathValue = (pathValue, navItem) => {
  if (isNil(pathValue)) return "";
  if (is(String, pathValue)) return pathValue;
  if (is(Function, pathValue)) return pathValue(navItem);
  return "";
};
const isPathArray = pathValue => {
  if (isNil(pathValue)) return false;
  if (is(Array, pathValue)) return true;
  return false;
};
const NavigationItem = ({
  navItem,
  theme,
  onNavigate,
  isTwoLevelMenu,
  subMenuActive = false,
  navItemFather = {},
  notifications = []
}) => {
  var _theme$colors, _theme$colors$text, _theme$colors2, _theme$colors2$text, _theme$colors3, _theme$colors3$text;
  const {
    pathname
  } = useLocation();
  const isCurrentLocation = isPathArray(navItem === null || navItem === void 0 ? void 0 : navItem.path) ? navItem.path.reduce((veredict, current) => veredict || pathname.includes(getPathValue(current, {})), false) : pathname.includes(getPathValue(navItem === null || navItem === void 0 ? void 0 : navItem.path, navItem));
  const [deployedSubItems, setDeployedSubItems] = useState(false);
  const [activeHover, setActiveHover] = useState(false);
  const existNavItems = !isNil(navItem === null || navItem === void 0 ? void 0 : navItem.navigationItems);
  const findNavigationItemHaveNotification = textToSearch => notifications.find(notificationObject => Object.keys(notificationObject)[0] === textToSearch);
  const navigationItemHaveNotification = findNavigationItemHaveNotification(navItem.text);
  const itemOfFirstLevelHaveNotifications = existNavItems ? navItem.navigationItems.filter(itemSeconLevel => findNavigationItemHaveNotification(itemSeconLevel.text)) : false;
  const onLinkClick = () => {
    if (subMenuActive) {
      const menuLinkText = navItemFather.text;
      const subMenuLinkText = navItem.text;
      GTMEvents.LateralMenuLinkSubMenu(menuLinkText, subMenuLinkText);
    } else GTMEvents.LateralMenuLinkMenu(navItem.text);
  };
  const NavIcon = ({
    hoverColor
  }) => {
    const Icon = navItem.icon;
    return /*#__PURE__*/React.createElement(NavigationIconWrapperStyled, {
      isTwoLevelMenu: isTwoLevelMenu,
      theme: theme,
      hoverColor: hoverColor,
      isCurrentLocation: isCurrentLocation
    }, is(String, Icon) ? /*#__PURE__*/React.createElement("img", {
      src: Icon
    }) : /*#__PURE__*/React.createElement(Icon, null));
  };
  const showIcon = (isCurrentLocation || isTwoLevelMenu) && !isNil(navItem === null || navItem === void 0 ? void 0 : navItem.icon);
  useEffect(() => {
    setDeployedSubItems(isCurrentLocation);
  }, [pathname]);
  useEffect(() => {
    if (existNavItems && !isEmpty(notifications) && !isEmpty(itemOfFirstLevelHaveNotifications)) {
      const subItemWithNotification = itemOfFirstLevelHaveNotifications[0].text;
      const notificationOfsubItemIsInteger = findNavigationItemHaveNotification(subItemWithNotification)[subItemWithNotification];
      setDeployedSubItems(!!notificationOfsubItemIsInteger);
    }
  }, [notifications, existNavItems]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationItemContainer, {
    isCurrentLocation: isCurrentLocation,
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu,
    subMenuActive: subMenuActive
  }, /*#__PURE__*/React.createElement(CustomLink$1, {
    to: isNil(navItem === null || navItem === void 0 ? void 0 : navItem.pathLink) ? getPathValue(navItem === null || navItem === void 0 ? void 0 : navItem.path, navItem) : getPathValue(navItem === null || navItem === void 0 ? void 0 : navItem.pathLink, navItem),
    onNavigate: onNavigate,
    onLinkClick: onLinkClick
  }, showIcon && /*#__PURE__*/React.createElement(NavIcon, {
    hoverColor: activeHover
  }), isTwoLevelMenu ? /*#__PURE__*/React.createElement(StyledItemText, {
    onMouseEnter: () => {
      setActiveHover(true);
    },
    onMouseLeave: () => {
      setActiveHover(false);
    },
    subMenuActive: subMenuActive,
    activeColor: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$text = _theme$colors.text) === null || _theme$colors$text === void 0 ? void 0 : _theme$colors$text.active,
    color: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : (_theme$colors2$text = _theme$colors2.text) === null || _theme$colors2$text === void 0 ? void 0 : _theme$colors2$text.color,
    onHoverColor: theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : (_theme$colors3$text = _theme$colors3.text) === null || _theme$colors3$text === void 0 ? void 0 : _theme$colors3$text.dark,
    isCurrentLocation: activeHover ? !activeHover : isCurrentLocation,
    showIcon: showIcon
  }, navItem.text) : /*#__PURE__*/React.createElement("p", null, navItem.text)), !showIcon && navigationItemHaveNotification && !!navigationItemHaveNotification[navItem.text] && /*#__PURE__*/React.createElement(Notification, {
    theme: theme
  }, navigationItemHaveNotification[navItem.text]), isTwoLevelMenu && showIcon && existNavItems && /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setDeployedSubItems(!deployedSubItems);
    },
    style: {
      cursor: "pointer",
      "margin-right": "0px",
      "margin-left": "auto"
    }
  }, deployedSubItems ? /*#__PURE__*/React.createElement(ContractedArrow, {
    theme: theme,
    isCurrentLocation: isCurrentLocation
  }) : /*#__PURE__*/React.createElement(DeployArrow, {
    theme: theme,
    isCurrentLocation: isCurrentLocation
  }))), existNavItems && isTwoLevelMenu && deployedSubItems && (navItem === null || navItem === void 0 ? void 0 : navItem.navigationItems.map((subNavItem, index) => /*#__PURE__*/React.createElement(NavigationItem, {
    key: `${subNavItem.text}-${index}`,
    notifications: notifications,
    navItem: subNavItem,
    subMenuActive: true,
    navItemFather: navItem,
    theme: theme,
    onNavigate: onNavigate,
    isTwoLevelMenu: isTwoLevelMenu
  }))));
};

const Navigation = ({
  navItems = [],
  theme,
  onNavigate,
  isTwoLevelMenu,
  notifications
}) => {
  return /*#__PURE__*/React.createElement(NavigationListStyled, {
    isTwoLevelMenu: isTwoLevelMenu
  }, navItems.map((navItem, index) => /*#__PURE__*/React.createElement(NavigationItem, {
    navItem: navItem,
    key: `${navItem.text}-${index}`,
    onNavigate: onNavigate,
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu,
    notifications: notifications
  })));
};

function MenuButton({
  colors
}) {
  return /*#__PURE__*/React.createElement(BaseMenuButton, {
    color: colors.secondary
  }, /*#__PURE__*/React.createElement(MenuTitleStyled, null, "Men\xFA"), " ", /*#__PURE__*/React.createElement(BarsIcon, {
    color: colors.primary
  }));
}

const HeaderNavigation = ({
  isActiveMenu,
  setIsActiveMenu,
  theme,
  isTwoLevelMenu
}) => {
  var _theme$colors, _theme$colors2, _theme$colors3;
  const toggleMenu = () => setIsActiveMenu(active => !active);
  return /*#__PURE__*/React.createElement(HeaderWrapperStyled, {
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement(Logo, {
    theme: theme === null || theme === void 0 ? void 0 : theme.name,
    isTwoLevelMenu: isTwoLevelMenu
  }), /*#__PURE__*/React.createElement(ToggleMenuIconStyled, {
    onClick: toggleMenu
  }, isActiveMenu ? /*#__PURE__*/React.createElement(CloseIcon, {
    color: theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.secondary
  }) : /*#__PURE__*/React.createElement(MenuButton, {
    colors: {
      primary: theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.primary,
      secondary: theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3.secondary
    }
  })));
};

const BodyWrapperStyled = styled.div.withConfig({
  displayName: "styles__BodyWrapperStyled",
  componentId: "sc-4y1fav-0"
})(["background-color:", ";position:fixed;z-index:3;top:0;left:0;right:0;bottom:0;transform:", ";height:100vh;padding-top:63px;transition:transform 0.3s ease 0s,opacity 0.3s ease 0s;will-change:transform;", ""], props => {
  var _props$theme, _props$theme$colors, _props$theme2;
  return props.isTwoLevelMenu ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : _props$theme$colors.primary : props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.color;
}, props => props.isActiveMenu ? 'translateY(0px)' : 'translateY(-100vh)', media.md`
            position: relative;
            padding: 0px;
            transform: none;
            height: 100%;
            transition: none;
        `);

const BodyNavigation = ({
  children,
  isActiveMenu,
  theme,
  isTwoLevelMenu
}) => {
  return /*#__PURE__*/React.createElement(BodyWrapperStyled, {
    isActiveMenu: isActiveMenu,
    theme: theme,
    isTwoLevelMenu: isTwoLevelMenu
  }, children);
};

const localTheme = {
  dark: {
    name: "dark",
    color: "#696158",
    secundaryColor: ""
  },
  orange: {
    name: "orange",
    color: "#FF4F00"
  },
  white: {
    name: "white",
    color: "#FF4F00",
    colors: {
      primary: "#FFFFFF",
      secondary: "#FF4F00",
      text: {
        color: "#AAA9A9",
        active: "#FF4F00",
        hover: "#696158",
        dark: "#696158"
      },
      card: {
        background: "#FFFFFF"
      }
    },
    sayMyName: "Heisenberg"
  }
};
const LateralMenu = _ref => {
  let {
    children,
    navItems = [],
    notifications = [],
    userInformation = {},
    closeSession = {},
    theme = "orange",
    isTwoLevelMenu = false,
    userModule = {},
    navigation = {}
  } = _ref;
  const [isActiveMenu, setIsActiveMenu] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);
  let OS = getOS();
  let BROWSER = getBrowser();
  const deviceIos = ["Mac OS", "iOS"];
  useEffect(() => {
    const subscribeToResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", subscribeToResize);
    return () => window.removeEventListener("resize", subscribeToResize);
  }, [window.innerWidth]);
  useEffect(() => {
    setIsMobile(windowWidth <= 1138);
  }, [windowWidth]);
  useEffect(() => {
    if (navigation !== null && navigation !== void 0 && navigation.onNavigate && isActiveMenu) {
      setIsActiveMenu(active => !active);
    }
  }, [navigation]);
  const marginBottomContentMobile = deviceIos.includes(OS) || equals(BROWSER, "firefox");
  return /*#__PURE__*/React.createElement(MenuWrapperStyled, {
    theme: prop(theme, localTheme),
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement(HeaderNavigation, {
    isActiveMenu: isActiveMenu,
    setIsActiveMenu: setIsActiveMenu,
    theme: prop(theme, localTheme),
    isTwoLevelMenu: isTwoLevelMenu
  }), /*#__PURE__*/React.createElement(BodyNavigation, {
    isActiveMenu: isActiveMenu,
    theme: prop(theme, localTheme),
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement("div", {
    className: "tw-flex tw-flex-col tw-justify-between"
  }, /*#__PURE__*/React.createElement(ContendScrollableStyled, {
    marginBottomMobile: marginBottomContentMobile,
    isTwoLevelMenu: isTwoLevelMenu
  }, /*#__PURE__*/React.createElement(UserInformation, {
    subTitle: userInformation.subTitle,
    title: userInformation.title,
    userModule: userModule,
    theme: prop(theme, localTheme),
    onNavigate: navigation === null || navigation === void 0 ? void 0 : navigation.onNavigate,
    nameInitials: (userInformation === null || userInformation === void 0 ? void 0 : userInformation.nameInitials) || "XX",
    isTwoLevelMenu: isTwoLevelMenu
  }), /*#__PURE__*/React.createElement(Navigation, {
    navItems: navItems,
    theme: prop(theme, localTheme),
    onNavigate: navigation === null || navigation === void 0 ? void 0 : navigation.onNavigate,
    isTwoLevelMenu: isTwoLevelMenu,
    notifications: notifications
  })), /*#__PURE__*/React.createElement(CloseSession, {
    onClick: closeSession === null || closeSession === void 0 ? void 0 : closeSession.onClick,
    theme: prop(theme, localTheme),
    isTwoLevelMenu: isTwoLevelMenu
  }))), children);
};
LateralMenu.propTypes = {
  navItems: PropTypes.array,
  userInformation: PropTypes.object,
  closeSession: PropTypes.object,
  theme: PropTypes.string,
  userModule: PropTypes.object,
  navigation: PropTypes.object
};

export { AppRouter, LateralMenu };
